/** Must stay aligned with `Tawan Spa/server/utils/referral.js`. */
export const REFERRAL_COOKIE = "drhoffmann_referral_code";
const MAX_AGE_SEC = 60 * 60 * 24 * 30;

const readCookie = (name) => {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  const hit = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!hit) return null;
  try {
    return decodeURIComponent(hit.slice(prefix.length));
  } catch {
    return hit.slice(prefix.length);
  }
};

const writeCookie = (name, value) => {
  if (typeof document === "undefined" || !value) return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${MAX_AGE_SEC}; SameSite=Lax`;
};

/** Persist ?ref= from any landing page for registration attribution. */
export const captureReferralFromLocation = (location) => {
  if (!location) return;
  const ref = new URLSearchParams(location.search || "").get("ref")?.trim();
  if (!ref) return;
  writeCookie(REFERRAL_COOKIE, ref.toUpperCase());
};

export const getStoredReferralCode = () => readCookie(REFERRAL_COOKIE);

export const getReferralCodeFromLocation = (location) => {
  const fromUrl = new URLSearchParams(location?.search || "").get("ref")?.trim();
  return (fromUrl || getStoredReferralCode() || "").toUpperCase();
};

const isStarterPackageOption = (option) =>
  String(option?.hoffmannBookingOption || option?.title || "")
    .toLowerCase()
    .includes("starterpaket");

const isBusinessEventOption = (option) =>
  option?.serviceKey === "dr-hoffmann-business-event" ||
  String(option?.hoffmannBookingOption || "")
    .toLowerCase()
    .includes("wm-aktion");

/** Client-side mirror of server eligibility for massage-only referral balance. */
export const isReferralBalanceEligibleOption = (option) => {
  if (!option?.serviceKey?.startsWith("dr-hoffmann-")) return false;
  if (option.serviceKey === "dr-hoffmann-consultation") return false;
  if (isStarterPackageOption(option) || isBusinessEventOption(option)) return false;
  return true;
};
